class GtmClass {
  constructor () {
    this.$store = null
    window.dataLayer = window.dataLayer || []
  }

  init (store) {
    this.$store = store
  }

  push (data) {
    console.log('dataLayer', data)
    window.dataLayer.push(data)
  }

  trackStep (step) {
    this.push({
      event: 'Step',
      event_category: 'Step',
      event_label: `Step ${step + 1}`
    })
  }

  trackNext (step) {
    this.push({
      event: 'click',
      event_category: 'Next',
      event_label: `Next ${step + 1}`
    })
  }

  trackSubmit () {
    this.push({
      event: 'submit',
      event_category: 'Submit',
      event_label: 'Conversion submit'
    })
  }
}

const gtm = new GtmClass()

export { GtmClass, gtm }
export default gtm
